import { combineReducers, Reducer, AnyAction } from 'redux';
import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';
import storage from 'redux-persist/lib/storage';
import persistReducer from 'redux-persist/es/persistReducer';
import { PersistPartial } from 'redux-persist/es/persistReducer';

import { authReducer, AuthState } from '../common/auth/auth.reducer';
import { sessionReducer } from '../common/session/session.reducer';
import { configurationReducer } from '../common/configuration/configuration.reducer';

const authPersistConfig = {
  key: 'auth',
  storage: storage,
  blacklist: ['isLoading', 'error'],
  timeout: undefined as unknown as number,
};

type PersistedAuthState = AuthState & PersistPartial;

const persistedAuthReducer: Reducer<PersistedAuthState, AnyAction> = persistReducer<PersistedAuthState>(
  authPersistConfig,
  authReducer as unknown as Reducer<PersistedAuthState, AnyAction>
);

export const createRootReducer = (history: History) => {
  const commonReducer = combineReducers({
    auth: persistedAuthReducer,
    session: sessionReducer,
  });

  return combineReducers({
    common: commonReducer,
    configuration: configurationReducer,
    router: connectRouter(history),
  });
};

export type State = ReturnType<ReturnType<typeof createRootReducer>> & { router: RouterState };
